window.App.OrderControl = {
    _data: null,
    _url: null,
    _timeout: null,
    _timeoutId: null,

    init(data, url) {
        this._data = data;
        this._url = url;
        
        window.addEventListener('LokiRequestEnd', () => {
            if (this._timeoutId) {
                clearTimeout(this._timeoutId);
            }
        })

        this._run();
    },

    _run() {
        if (this._timeout === null) {
            this._timeout = 2000;
        } else if (this._timeout === 2000) {
            this._timeout = 5000;
        } else {
            this._timeout = 10000;
        }

        this._timeoutId = setTimeout(() => {
            fetch(this._url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }

                    throw new Error('Network response was not ok');
                })
                .then(data => {
                    if (this._data._version !== data._version) {
                        LokiController.reload();
                        
                        return; 
                    }
                    
                    this._run();

                })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
                });
        }, this._timeout); 
    },
};
